import React from "react";
import NavBar from "../Base/NavBar.js";

export default function AboutUs() {
    return (
            <div>
                <NavBar></NavBar>
                <div>
                   About Us
                </div>
            </div>

        );
}
